import React from "react";
import { withFormsy } from "formsy-react";

import connect from "../../../i18n/connect";
import FormsyBase from "./FormsyBase";
import InputText from "../../../web/components/common/inputs/InputText/InputText";

@connect()
@withFormsy
class FormsyComposedNewTextField extends FormsyBase {
  render() {
    const {
      name,
      label,
      value,
      errorMessage,
      translate,
      disabled,
      buttonText,
      onButtonClick,
      disableButton,
      maxLength,
      onBlur,
      inputType,
      inputMode,
      autoComplete,
      translateLabel = true,
      selectTextOnFocus = false,
      endChild
    } = this.props;

    const showError = this.showError();

    return (
      <InputText
        name={name}
        label={translateLabel ? translate(label) : label}
        value={value || ""}
        onChange={newValue => this.handleChange(newValue)}
        onBlur={onBlur}
        errorMessage={showError ? translate(errorMessage) : null}
        disabled={disabled}
        buttonText={buttonText}
        onButtonClick={onButtonClick}
        disableButton={disableButton}
        maxLength={maxLength}
        inputType={inputType}
        inputMode={inputMode}
        autoComplete={autoComplete}
        selectTextOnFocus={selectTextOnFocus}
        endChild={endChild}
      />
    );
  }
}

export default FormsyComposedNewTextField;
